"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseAuthenticationServiceClient_1 = __importDefault(require("../common/BaseAuthenticationServiceClient"));
const webEncryptPassword_1 = require("./webEncryptPassword");
class AuthenticationServiceClient extends BaseAuthenticationServiceClient_1.default {
    constructor(fetch, options) {
        super(fetch, options, webEncryptPassword_1.encryptPassword);
    }
}
exports.default = AuthenticationServiceClient;
